import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';

import SwitchForm from '../components/SwitchForm';
import './EventFilterExpose.scss';

interface EventFilterExposeProps extends FormComponentProps {
  name: string;
  initialValue: boolean;
}
const EventFilterExpose = (props: EventFilterExposeProps) => {
  const { form, name, initialValue } = props;

  return (
    <SwitchForm
      className="event-filter-expose"
      form={form}
      label="필터 사용 여부"
      name={name}
      initialValue={initialValue}
      subContent={
        <div className="sub-content">
          <p>*기획전에 등록 된 아이템 정보(상품)에 대해서만 상품 정보를 필터링 할 수 있습니다.</p>
          <p>*섹션 아이템 영역에 등록 된 상품은 필터링에서 제외 됩니다.</p>
        </div>
      }
    />
  );
};
export default EventFilterExpose;
